import { createApp } from 'vue';
import ModalNav from './components/ModalNav.vue';
import Modal from './components/Modal.vue';
import Carousel from './components/Carousel.vue';
import Accordion from './components/Accordion.vue';
import { SwiperSlide } from 'swiper/vue';
import JSShare from "js-share";

const app = createApp({});
app
    .component('modal-nav', ModalNav)
    .component('modal', Modal)
    .component('carousel', Carousel)
    .component('slide', SwiperSlide)
    .component('accordion', Accordion)
    .mount('#app')

/**
 * External Dependencies
 */
document.querySelectorAll('[data-toggle-class]').forEach((element) => {
    element.addEventListener('click', (event) => {
        event.preventDefault();
        const [target, className] = element.getAttribute('data-toggle-class').split(':');
        document.querySelector(target).classList.toggle(className);
    });
});

var shareItems = document.querySelectorAll('.social_share');
for (var i = 0; i < shareItems.length; i += 1) {
    shareItems[i].addEventListener('click', function share(e) {
        return JSShare.go(this);
    });
}
